import { track } from '@eventbrite/datalayer-library';

// Heap tracking
export const HEAP_EVENT_NAME_SIGNUP_SUCCESSFUL =
    'Creator Acquisition - All - All- Click- Signup';
export const LOGIN_METHOD_EMAIL = 'Email';
export const LOGIN_METHOD_FACEBOOK = 'Facebook';
export const LOGIN_METHOD_APPLE = 'Apple';
export const LOGIN_METHOD_GOOGLE = 'Google';
export const SIGN_UP_TYPE_LOGGED_OUT_EVENT_CREATE = 'LoggedOutEventCreate';
export const SIGN_UP_SUCCESS = 'SignUpSuccess';
export const SIGNUP_TYPE_LOGGED_OUT = 'logged-out'; // As specified in EB-256923.
export const SIGNUP_TYPE_LOGGED_OUT_AUTH0 = 'logged-out-auth0';

const socialMap: { [key: string]: string } = {
    google: LOGIN_METHOD_GOOGLE,
    facebook: LOGIN_METHOD_FACEBOOK,
    apple: LOGIN_METHOD_APPLE,
};

export const trackSocialSignUp = (socialProvider: string) => {
    // Generic platform-wide signup event.
    track({
        eventName: HEAP_EVENT_NAME_SIGNUP_SUCCESSFUL,
        eventData: {
            signupType: SIGNUP_TYPE_LOGGED_OUT,
            signupMethod: socialMap[socialProvider],
        },
    });

    // Logged-out specific signup event.
    track({
        eventName: SIGN_UP_SUCCESS,
        eventData: {
            signupType: SIGN_UP_TYPE_LOGGED_OUT_EVENT_CREATE,
            signupMethod: socialMap[socialProvider],
        },
    });
};
